<div class="logout-container">
    <div class="logout-card">
        <div class="logout-icon">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17 7L15.59 8.41L18.17 11H8V13H18.17L15.59 15.59L17 17L22 12L17 7Z" fill="#bf9000" />
                <path
                    d="M19 19H5V5H12V3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V13H19V19Z"
                    fill="#bf9000" />
            </svg>
        </div>

        <div class="logout-content">
            <h1 class="logout-title">Session Terminated</h1>
            <p class="logout-message">
                You have been successfully logged out. Your session has been terminated for security purposes.
            </p>
            <p class="logout-submessage">Thank you for using Pulse. We hope to see you again soon!</p>
        </div>

        <div class="logout-actions">
            <button
                type="button"
                class="btn btn-primary logout-btn"
                (click)="navigateToHome()"
                [disabled]="isRedirecting">
                @if (!isRedirecting) {
                    <span class="btn-content">
                        <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            class="btn-icon">
                            <path d="M10 20V14H14V20H19V12H22L12 3L2 12H5V20H10Z" fill="currentColor" />
                        </svg>
                        Return to Login
                    </span>
                }
                @if (isRedirecting) {
                    <span class="btn-content">
                        <div class="spinner"></div>
                        Redirecting...
                    </span>
                }
            </button>
        </div>

        <div class="logout-footer">
            <small class="text-muted"> For any issues, please contact support using the right button. </small>
        </div>
    </div>
</div>
